/**
 * user_type 값 (저장/파싱 기준)
 * 개인: Missionary, Pastor, Staff, Private
 * 단체: NGO, Church, Orphanage, SmallGroup, MissionSchool, ETC
 */
export const normalizeUserType = (value?: string) =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '');

const INDIVIDUAL_USER_TYPES = new Set(['missionary', 'pastor', 'staff', 'private', 'individual']);

/** 개인 유형 중 소속 단체명이 필수인 유형 (교회 사역자, 선교사, 선교단체 사역자) */
const INDIVIDUAL_ORG_REQUIRED = new Set(['missionary', 'pastor', 'staff']);

/** 개인 유형 중 소속 기관명 드롭다운 사용 (선교사, 선교단체 사역자) */
const INDIVIDUAL_ORG_DROPDOWN = new Set(['missionary', 'staff']);

export const isIndividualUserType = (value?: string) => {
  return INDIVIDUAL_USER_TYPES.has(normalizeUserType(value));
};

/** 개인 유형일 때 소속 단체명 필수 여부 (Private/개인 기타는 선택) */
export const isOrganizationRequiredForIndividual = (value?: string) => {
  return INDIVIDUAL_ORG_REQUIRED.has(normalizeUserType(value));
};

/** 개인 유형일 때 소속 기관명 드롭다운 사용 여부 (선교사, 선교단체 사역자) */
export const isOrganizationDropdownForIndividual = (value?: string) => {
  return INDIVIDUAL_ORG_DROPDOWN.has(normalizeUserType(value));
};
